export default {
    basicData: "basicData",
    purchaserData: "purchaserData",
    realizationType: "realizationType",
    documentsAccess: "documentsAccess",
    orderObject: "orderObject",
    qualification: "qualification",
    objectiveEvidence: "objectiveEvidence",
    orderTerms: "orderTerms",
    contractDraft: "contractDraft",
    orderDetails: "orderDetails",
    additionalInfo: "additionalInfo"
}

export const contractNoticeStepsOrder = ["basicData", "purchaserData", "realizationType", "documentsAccess", "orderObject", "qualification",
    "objectiveEvidence", "orderTerms", "contractDraft", "orderDetails", "additionalInfo"];